import IconButton from '@mui/material/IconButton';
import InfoIcon from '@mui/icons-material/Info';

interface InfoIconProps {
	id: string;
	onClick: () => void;
	isMobile: boolean;
}

const SelectIcon = ({ id, onClick, isMobile }: InfoIconProps) => (
	<IconButton
		color='icon'
		aria-label={`${id ?? ''} more info`}
		component='span'
		onClick={onClick}
		sx={{
			my: isMobile ? 0 : 1,
			width: isMobile ? 'auto' : '8%',
			ml: isMobile ? 1 : 0,
			p: isMobile ? 0.5 : 1,
		}}
	>
		<InfoIcon fontSize={isMobile ? 'small' : 'medium'} />
	</IconButton>
);

export default SelectIcon;
